import React from "react";
import { MONTHS, ORDINALS, WEEKDAYS } from "./options";

/* Was an uncontrolled stack of antd Row/Col, including a "Recur every N
   Year(s)" line the new design drops. Now a controlled panel of the Custom
   modal. Previous version in git history. */

/**
 * Year panel of the Custom recurrence modal.
 *
 *   value: { type: "on" | "onThe", month, day, ordinal, weekday, theMonth }
 *
 * Styles come from CustomRecurrenceModal.css, which the modal imports.
 */
export default function YearlyForm({ value, onChange }) {
  const set = (patch) => onChange({ ...value, ...patch });
  const onDate = value.type === "on";

  return (
    <div className="crm-section">
      <div className="crm-section-title">Repeat On:</div>

      <label className="crm-row">
        <input type="radio" name="crm-yearly-type" checked={onDate} onChange={() => set({ type: "on" })} />
        <span className="crm-row-label">On</span>
        <select
          className="crm-select"
          value={value.month}
          onFocus={() => set({ type: "on" })}
          onChange={(e) => set({ type: "on", month: e.target.value })}
        >
          {MONTHS.map((m) => (
            <option key={m.value} value={m.value}>
              {m.label}
            </option>
          ))}
        </select>
        <input
          type="number"
          min="1"
          max="31"
          className="crm-num"
          value={value.day}
          onFocus={() => set({ type: "on" })}
          onChange={(e) => set({ type: "on", day: e.target.value })}
        />
      </label>

      <label className="crm-row">
        <input type="radio" name="crm-yearly-type" checked={!onDate} onChange={() => set({ type: "onThe" })} />
        <span className="crm-row-label">On the</span>
        <select
          className="crm-select"
          value={value.ordinal}
          onFocus={() => set({ type: "onThe" })}
          onChange={(e) => set({ type: "onThe", ordinal: e.target.value })}
        >
          {ORDINALS.map((o) => (
            <option key={o.value} value={o.value}>
              {o.label}
            </option>
          ))}
        </select>
        <select
          className="crm-select"
          value={value.weekday}
          onFocus={() => set({ type: "onThe" })}
          onChange={(e) => set({ type: "onThe", weekday: e.target.value })}
        >
          {WEEKDAYS.map((d) => (
            <option key={d.value} value={d.value}>
              {d.label}
            </option>
          ))}
        </select>
        <span className="crm-row-label">of</span>
        <select
          className="crm-select"
          value={value.theMonth}
          onFocus={() => set({ type: "onThe" })}
          onChange={(e) => set({ type: "onThe", theMonth: e.target.value })}
        >
          {MONTHS.map((m) => (
            <option key={m.value} value={m.value}>
              {m.label}
            </option>
          ))}
        </select>
      </label>
    </div>
  );
}
